import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import GModal from 'tennders-market/common/components/element/GModal'
import { StateType } from 'tennders-common/types/StateType'
import { dispatchCompanyFlowModal } from 'tennders-common/stores/modal/action'
import GHref from 'tennders-market/common/components/element/GHref'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'

const MCarrierCompanyFlow = (props) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const router = useRouter()
  const isOpen = useSelector((state:StateType) => state.modal.companyFlow)
  const close = () => {
    dispatch(dispatchCompanyFlowModal(null))
  }
  useEffect(() => {
    close()
  }, [router.pathname])

  return (
    <GModal
      size={500}
      isOpen={!!isOpen}
      close={close}
      {...props}
    >
      <div className="tennders-modal-body w-100">
        <h3 className="bold">{t('modal:carrierCompanyFlowTitle')}</h3>
        <div className="d-flex row">
          <div className="d-flex col w-50">
            <GHref
              href="/add/company?type=carrier&flow=createProfile"
              onClick={close}
              className="btn-border d-flex justify-center standard-btn mb-10 small mr-4 cursor-pointer">{t('modal:createCarrierProfile')}
            </GHref>
            <p className="text-11 mr-4">
              <FontAwesomeIcon icon={faCircleInfo} size="lg" className="mr-4" />
              {t('modal:createCarrierProfileInfo')}
            </p>
          </div>

          <div className="d-flex col w-50">
            <GHref
              href="/add/company?type=carrier&flow=onBoarding"
              onClick={close}
              className="btn-border d-flex justify-center standard-btn mb-10 small cursor-pointer">{t('modal:onBoardNewCarrier')}
            </GHref>
            <p className="text-11 mr-4">
              <FontAwesomeIcon icon={faCircleInfo} size="lg" className="mr-4" />
              {t('modal:onBoardNewCarrierInfo')}
            </p>
          </div>
        </div>
      </div>
    </GModal>
  )
}

export default MCarrierCompanyFlow
